import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

/**
 * Ionic reutiliza rutas con el mismo componente; login empresa ↔ maestra deben remontarse.
 */
@Injectable()
export class AppRouteReuseStrategy extends IonicRouteStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const futurePath = future.routeConfig?.path ?? '';
    const currPath = curr.routeConfig?.path ?? '';
    if (
      futurePath.includes('iniciar-sesion') &&
      currPath.includes('iniciar-sesion') &&
      futurePath !== currPath
    ) {
      return false;
    }
    const leavingLogin =
      currPath.includes('iniciar-sesion') &&
      (futurePath === 'empresas' ||
        futurePath.startsWith('empresas/') ||
        futurePath === 'panel' ||
        futurePath.startsWith('panel'));
    if (leavingLogin) {
      return false;
    }
    const enteringPanelFromLogin =
      currPath.includes('iniciar-sesion') &&
      (future.url?.some((seg) => seg.path === 'panel') ?? false);
    if (enteringPanelFromLogin) {
      return false;
    }
    const elegirEmpresaPath = 'empresas/elegir-empresa';
    const involvesElegirEmpresa =
      futurePath === elegirEmpresaPath ||
      currPath === elegirEmpresaPath ||
      futurePath.includes('elegir-empresa') ||
      currPath.includes('elegir-empresa');
    if (involvesElegirEmpresa && futurePath !== currPath) {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}
